import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
// import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "./indexStyle";

//React-Table
import "react-table-v6/react-table.css";
//Semantic-UI React
import "semantic-ui-css/semantic.min.css";
//Rsuite
import "rsuite/dist/rsuite.min.css";
import ptBR from "rsuite/locales/pt_BR";
import { CustomProvider } from "rsuite";
//Moment.js
import * as moment from "moment";
import "moment/locale/pt-br";
import "./index.css";

//Reducer
import store from "./store";

moment.locale("pt-br");
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <CustomProvider locale={ptBR}>
        <BrowserRouter>
          <ThemeProvider theme={theme}>
            <App />
          </ThemeProvider>
        </BrowserRouter>
      </CustomProvider>
    </Provider>
  // </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

